var Vendd = (function (Vendd) {
    'use strict';

    var tempPostCode = '';
    var tempPostCodeFirstAccess = true;
    var tempAreas = '';
    var countries = '';
    var taxAgencies = '';
    var vatStatuses = '';
    var validateAreas = false;
    var addressValEngine = '';
    var observable = '';
    var validationModel;

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ConvertPointsToCoupons, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsFailed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsFailed(response));
        }
        var options = {
            url: 'EcomService.svc/ConvertPointsToCoupons',
            data: {
                accountId: envelope.message.data.accountId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddresses, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            var model = response;
            var observableAddresses = [];

            for (var i = 0; i < model.Addresses.length; i++) {
                var address = model.Addresses[i];

                var observable = new Vendd.Observable(address);
                observableAddresses.push(observable);
            }

            model.Addresses = observableAddresses;

            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressesSuccess(model));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressesFailed(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
                    ? 'AccountService.svc/GetShippingAddressesViewModel'
                    : 'AccountService.svc/GetBillingAddressesViewModel';

        var options = {
            url: url,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditUser, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            if (response.success === true && response.code === "AccountEdit_OperationSuccesful") {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserSuccess(response));

                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UpdateNewLetterVariables(3, null));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserFailed(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserFailed(response));
        }

        var options = {
            url: 'AuthService.svc/EditUser',
            data: {
                firstName: envelope.message.data.model.FirstName,
                lastName: envelope.message.data.model.LastName,
                userName: envelope.message.data.model.UserName,
                email: envelope.message.data.model.Email,
                oldPassword: envelope.message.data.model.OldPassword,
                password: envelope.message.data.model.Password,
                passwordConfirmation: envelope.message.data.model.PasswordConfirmation,
                newsletter: envelope.message.data.model.Newsletter,
                phones: envelope.message.data.model.Phones,
                mobilephone: envelope.message.data.model.MobilePhone,
                birthDate: envelope.message.data.model.BirthDate,
                IsLoyaltyMember: envelope.message.data.model.IsLoyaltyMember,
                LoyaltyRequest: envelope.message.data.model.LoyaltyRequest,
                LoyaltyMemberId: envelope.message.data.model.LoyaltyMemberId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.SetDefaultAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {

            // Vendd.MessageBus.publishAsync(Account, new Vendd.Account.Messages.SetDefaultAddressSuccess());
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.AddressModelChanged());

        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.SetDefaultAddressFailure(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
                    ? 'CommonService.svc/SetDefaultShippingAddress'
                    : 'CommonService.svc/SetDefaultBillingAddress';


        var options = {
            url: url,
            data: {
                addressId: envelope.message.data.addressId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.DeleteAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {

            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.AddressModelChanged());

        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.DeleteAddressFailure(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
                    ? 'CommonService.svc/DeleteShippingAddress'
                    : 'CommonService.svc/DeleteBillingAddress';


        var options = {
            url: url,
            data: {
                addressId: envelope.message.data.addressId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressSuccess());
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressFailed(response));
        }

        var options = {
            url: 'AccountService.svc/EditUserAddress',
            data: {
                addressType: envelope.message.data.addressType,
                address: envelope.message.data.model
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExists, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressIfExistsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressIfExistsFailure(response));
        }

        var options = {
            url: 'CommonService.svc/CheckAddressIfExists',
            data: {
                addressId: envelope.message.data.model.Id,
                firstName: envelope.message.data.model.FirstName,
                lastName: envelope.message.data.model.LastName,
                addressLine1: envelope.message.data.model.AddressLine1,
                addressLine2: envelope.message.data.model.AddressLine2,
                city: envelope.message.data.model.City,
                postCode: envelope.message.data.model.PostCode,
                country: envelope.message.data.model.Country,
                area: envelope.message.data.model.Area,
                isBillingAddress: envelope.message.data.model.IsBilling,
                isShippingAddress: envelope.message.data.model.IsShipping
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCode, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            //Validate Only if its Called From OnChange
            tempAreas = response;
            if (envelope.message.data.validateAfterLoad === true) {
                var valOptions = {
                    ValidationEngine: addressValEngine,
                    PropertyName: 'PostCode',
                    PropertyValue: tempPostCode
                };

                validateAreas = false;
                Vendd.DataValidation.Validate(valOptions);
            }

            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAreasForPostCodeSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressFailed(response));
        }

        var options = {
            url: 'AccountService.svc/AreaLookUp',
            data: {
                countryCode: envelope.message.data.country,
                postalCode: envelope.message.data.postCode,
                selectedAreaCode: envelope.message.data.area
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCountries, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            countries = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCountriesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCountriesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetCountries',
            data: {
                selectedCountryCode: envelope.message.data.selectedCountryCode,
                addressType: envelope.message.data.addressType
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPrefecture, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefectureSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefectureFailed(response));
        }

        var options = {
            url: 'AccountService.svc/PrefectureLookUp',
            data: {
                countryCode: envelope.message.data.countryCode,
                postalCode: envelope.message.data.postCode,
                area: envelope.message.data.area
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllTaxAgencies, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            taxAgencies = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllTaxAgenciesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllTaxAgenciesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAllTaxAgencies',
            data: {
                countryCode: envelope.message.data.countryCode,
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllVatStatuses, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            vatStatuses = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllVatStatusesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllVatStatusesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAllVatStatuses',

            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetUserAccount, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            var model = response;
            var observable = new Vendd.Observable(model);
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetUserAccountSuccess(observable));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetUserAccountFailure(response));
        }

        var options = {
            url: 'AccountService.svc/GetUserAccountViewModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.RequestToDeleteUser, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToDeleteUserSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToDeleteUserFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/RequestToDeleteUser',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.RequestToExportData, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToExportDataSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToExportDataFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/RequestToExportData',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.Account.SelectedCountryChanged = function (observable) {
        observable.Area = '';
        observable.PostCode = '';
        observable.IsFirstAccess = true;

        countries.forEach(function (country) {
            country.Selected = false;
        });
        var currentCountry = _.where(countries, { Code: observable.Country });
        currentCountry[0].Selected = true;

        Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllTaxAgencies(observable));
    };

    Vendd.Account.SetObservable = function (observ) {
        observable = observ;
    }

    Vendd.Account.SetValidationModel = function (validationMod) {
        validationModel = validationMod;
    }

    Vendd.Account.ValidateObservable = function (observ) {

        if (observ == undefined) {
            observ = observable;
        }
        var valOptions = {
            ValidationEngine: addressValEngine,
            valmodel: observ.model,
        };
        Vendd.DataValidation.ValidateModel(valOptions);
    }


	Vendd.Account.SelectedPostCodeChanged = function (observable) {
	    observable.Area = '';
	    // Vendd.MessageBus.publishAsync(Account, new Vendd.Account.Messages.GetAreasForPostCode(observable, value, true));
	};

	Vendd.Account.GetNewAccount = function (observable) {

	    var newaddress = {
	        IsInvoiceEnabled: observable.IsInvoiceEnabled,
	        IsDefault: false,
	        FirstName: '',
	        LastName: '',
	        Title: '',
	        Bell: '',
	        AddressLine1: '',
	        AddressLine2: '',
	        Area: '',
	        City: '',
	        PostCode: '',
	        Country: '',
	        CountryDescription: '',
	        Phones: '',
	        Mobiles: '',
	        Fax: '',
	        IsInvoice: false,
	        InvoiceText: '',
	        CompanyName: '',
	        Occupation: '',
	        TaxIdentifier: '',
	        TaxAgency: '',
            VatStatus:0,
	        IsFirstAccess: true
	    };

	    var literals = { Literals: observable.Literals };
	    $.extend(newaddress, literals);
	    observable = new Vendd.Observable(newaddress);
	    return observable;
	};

	Vendd.Account.CreateDefaultAccountUserValidationModel = function (observable) {

	    var useEmailAsLoginName = observable.model.UseEmailAsLoginName;

	    var defaultValidationModel = {
	        FirstName: [{ rule: "required" }],
	        LastName: [{ rule: "required" }],
	        Email: [{ rule: "required" }, { rule: "isEmail" }]
	    };

	    if (!useEmailAsLoginName) {
	        defaultValidationModel.UserName = [{ rule: "required" }];
        }

        if (!venddProjectConfigs || !venddProjectConfigs.Account || !venddProjectConfigs.Account.EditForm || venddProjectConfigs.Account.EditForm.BirthDateRequired === true) {
            defaultValidationModel.BirthDate = [{ rule: "required" }];
        }

	    var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

	    var propertyChanging = function propertyChanging(data, propertyName, value) {

	        var valOptions = {
	            ValidationEngine: valEngine,
	            PropertyName: propertyName,
	            PropertyValue: value
            };
	        Vendd.DataValidation.Validate(valOptions);
	    };

	    var customUserAccountValidationModel = ({
	        PasswordConfirmation: [{ rule: "isEqualWithPassword" }],
	        Password: [{ rule: "isNotWeak" }, { rule: "isOldPasswordProperlySetPW" }],
	        OldPassword: [{ rule: "isOldPasswordProperlySetOP" }]
	    });

	    var isOldPasswordProperlySetPW = function (value) {
	        if (value.length == 0)
	            return true;

	        if (value.length > 0 && observable.OldPassword.length > 0)
	            return true;

	        return false;
	    };

	    var isOldPasswordProperlySetOP = function (value) {
	        if (value.length > 0 && observable.Password.length > 0)
	            return true;

	        if (observable.Password.length == 0)
	            return true;

	        return false;
	    };

	    var isEqualWithPassword = function (value) {
	        if (value.length > 0 && observable.Password === value) {
	            return true;
	        }

	        if (value.length == 0 && observable.Password === value) {
	            return true;
	        }

	        return false;
	    };

	    var isNotWeak = function (value) {
	        if (value.length == 0 && observable.PasswordConfirmation.length == 0)
	            return true;

	        var score = Vendd.Helpers.textStrength(value);
	        //1 is the weak value of passowrd we need more than weak
	        if (score > 2) {
	            return true;
	        }
	        return false;
	    };

	    valEngine.addOrUpdateValidationRule('isOldPasswordProperlySetPW', isOldPasswordProperlySetPW, 'Old password must be completed if a new password is requested');
	    valEngine.addOrUpdateValidationRule('isOldPasswordProperlySetOP', isOldPasswordProperlySetOP, 'Complete old password');
	    valEngine.addOrUpdateValidationRule('isEqualWithPassword', isEqualWithPassword, 'Confirmation must be equal with Password');
	    valEngine.addOrUpdateValidationRule('isNotWeak', isNotWeak, 'Password must not be weak');
	    valEngine.updateValidationModel(customUserAccountValidationModel);

	    observable.AddListenerToPropertyChanging('FirstName', propertyChanging);
	    observable.AddListenerToPropertyChanging('LastName', propertyChanging);
        observable.AddListenerToPropertyChanging('Email', propertyChanging);
        observable.AddListenerToPropertyChanging('BirthDate', propertyChanging);
	    observable.AddListenerToPropertyChanging('Password', propertyChanging);
	    observable.AddListenerToPropertyChanging('OldPassword', propertyChanging);
	    observable.AddListenerToPropertyChanging('PasswordConfirmation', propertyChanging);
	    return valEngine;
	};

	Vendd.Account.CreateDefaultAdressValidationModel = function (observable) {
        var valopts = {
            FirstName: [{ rule: "required" }],
            LastName: [{ rule: "required" }],
            // Phones: [{ rule: "required" }, { rule: "isNumeric" }],
            // Mobile: [{ rule: "required" }, { rule: "isNumeric" }],
            //PostCode: [{ rule: "required" }],
            AddressLine1: [{ rule: "required" }],
            City: [{ rule: "required" }],
            //Area: [{ rule: "required" }],
            Country: [{ rule: "required" }],
        };

        if (!venddProjectConfigs || !venddProjectConfigs.Account || !venddProjectConfigs.Account.Addresses || venddProjectConfigs.Account.Addresses.PhoneRequired === true) {
            valopts.Phones = [{ rule: "required" }, { rule: "isNumeric" }];
        }
        if (!venddProjectConfigs || !venddProjectConfigs.Account || !venddProjectConfigs.Account.Addresses || venddProjectConfigs.Account.Addresses.MobileRequired === true) {
            valopts.Mobiles = [{ rule: "required" }, { rule: "isNumeric" }];
        }
        var defaultValidationModel = (valopts);

	    addressValEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

	    //Add Custom Validation engine

	    //Custom Validations
	    var isValidPostCode = function (value) {
	        var selectedCounries = _.where(countries, {
	            Code: observable.Country
	        });
	        if (selectedCounries.length <= 0) {
	            return true;
	        }
	        if (selectedCounries.length > 0 && observable.PostCode == '' && observable.IsFirstAccess === true) {
	            observable.IsFirstAccess = false;
	            return true;
	        }

	        //id does not have any areas but postcode is properly completed
            if (selectedCounries[0].AreasCount < 2 && observable.PostCode) {
	            return true;
	        }

            if ((tempAreas.length > 0) && selectedCounries[0].AreasCount > 1) {
	            return true;
	        }

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidPostCode", isValidPostCode, 'This Property must be a valid Postal Code');

	    var isValidPhoneNumber = function (value) {
	        var reg = /^[\+]?[\d]+$/g;
	        return reg.test(value);
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidPhoneNumber", isValidPhoneNumber, 'This Property must be a valid Phone Number');

	    var isAreaProperlySet = function (value) {
	        if (observable.PostCode.length > 0 && isValidPostCode(observable.PostCode) && value.length > 0)
	            return true;

	        if (observable.PostCode.length <= 0)
	            return true;

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isAreaProperlySet", isAreaProperlySet, 'Area not completed');
        var extravalopts = {
            PostCode: [{ rule: "isValidPostCode" }],
            // Phones: [{ rule: "isValidPhoneNumber" }],
            // Mobile: [{ rule: "isValidPhoneNumber" }],
            Area: [{ rule: "isAreaProperlySet" }]
        };
        if (!venddProjectConfigs || !venddProjectConfigs.Account || !venddProjectConfigs.Account.Addresses || venddProjectConfigs.Account.Addresses.PhoneRequired === true) {
            extravalopts.Phones = [{ rule: "isValidPhoneNumber" }];
        }
        if (!venddProjectConfigs || !venddProjectConfigs.Account || !venddProjectConfigs.Account.Addresses || venddProjectConfigs.Account.Addresses.MobileRequired === true) {
            extravalopts.Mobiles = [{ rule: "isValidPhoneNumber" }];
        }
	    //Custom validation Model Custom Rules
        var customAccountValidationModel = (extravalopts);
	    addressValEngine.updateValidationModel(customAccountValidationModel);

	    // =======================================================================
	    // INVOICE VALIDATION
	    // =======================================================================

	    var isValidCompanyName = function (value) {
	        if (observable.IsInvoice === true && value.length > 0)
	            return true;

	        if (observable.IsInvoice !== true)
	            return true;

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidCompanyName", isValidCompanyName, 'Please insert Company Name');

	    var isValidOccupation = function (value) {
	        if (observable.IsInvoice === true && value.length > 0)
	            return true;

	        if (observable.IsInvoice !== true)
	            return true;

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidOccupation", isValidOccupation, 'Please insert Occupation');

	    var isValidTaxAgency = function (value) {
	        if (observable.IsInvoice === true && value.length > 0)
	            return true;

	        if (observable.IsInvoice !== true)
	            return true;

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidTaxAgency", isValidTaxAgency, 'Please insert a valid Tax Agency');

	    var isValidVatStatus = function (value) {
	        if (observable.IsInvoice === true && value.length > 0)
	            return true;

	        if (observable.IsInvoice !== true)
	            return true;

	        return false;
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidVatStatus", isValidVatStatus, 'Please insert a valid Vat Status');

	    var isValidTaxIdentifier = function (value) {
	        if (observable.IsInvoice !== true)
	            return true;

	        return LhApp.Function.validateTaxIdentifier(observable.IsInvoice, observable.Country, value);
	    };
	    addressValEngine.addOrUpdateValidationRule("isValidTaxIdentifier", isValidTaxIdentifier, 'Please insert a valid Tax Identifier');

	    // Custom validation Model for Invoice data
	    var customAccountInvoiceValidationModel = ({
	        CompanyName: [{ rule: 'isValidCompanyName' }],
	        Occupation: [{ rule: 'isValidOccupation' }],
	        TaxAgency: [{ rule: 'isValidTaxAgency' }],
	        TaxIdentifier: observable.IsInvoice ? [{ rule: "required" }, { rule: 'isValidTaxIdentifier' }] : [{ rule: 'isValidTaxIdentifier' }],
	    });
	    addressValEngine.updateValidationModel(customAccountInvoiceValidationModel);

	    //Validation Binding
	    var propertyChanging = function propertyChanging(data, propertyName, value) {
	        var valOptions = {
	            ValidationEngine: addressValEngine,
	            PropertyName: propertyName,
	            PropertyValue: value
	        };
	        Vendd.DataValidation.Validate(valOptions);
	    };

	    observable.AddListenerToPropertyChanging('FirstName', propertyChanging);
	    observable.AddListenerToPropertyChanging('LastName', propertyChanging);
	    observable.AddListenerToPropertyChanging('Mobile', propertyChanging);
	    observable.AddListenerToPropertyChanging('Phones', propertyChanging);
	    observable.AddListenerToPropertyChanging('AddressLine1', propertyChanging);
	    observable.AddListenerToPropertyChanging('City', propertyChanging);
	    //observable.AddListenerToPropertyChanging('PostCode', propertyChanging);
	    //observable.AddListenerToPropertyChanging('Country', propertyChanging);
	    observable.AddListenerToPropertyChanging('IsInvoice', propertyChanging);
	    observable.AddListenerToPropertyChanging('CompanyName', propertyChanging);
	    observable.AddListenerToPropertyChanging('Occupation', propertyChanging);
	    observable.AddListenerToPropertyChanging('TaxIdentifier', propertyChanging);
	    observable.AddListenerToPropertyChanging('TaxAgency', propertyChanging);
	    observable.AddListenerToPropertyChanging('VatStatus', propertyChanging);

	    observable.AddListenerToPropertyChanging('PostCode', function postpropertyChanging(data, propertyName, value) {
	        //if (observable.model.PostCode !== '') {
	        tempPostCode = value;
	        validateAreas = true;
	        Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAreasForPostCode(observable, value, true));
	        //}
	    });
	    //observable.AddListenerToPropertyChanging('Area', propertyChanging);
	    return addressValEngine;
	};

	Vendd.Account.EmptyAreasOnClose = function (observable) {

    };

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCouponInformations, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCouponInformationsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCouponInformationsFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/GetCouponInformations',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.InvalidateCouponCode, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.InvalidateCouponCodeSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.InvalidateCouponCodeFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/InvalidateCouponCode',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	return Vendd;

})(Vendd || {});